import React from 'react';

const slide = (props) => {
  return (
    <div>
      <blockquote className={props.side}>
        <p><span>{props.quote}</span></p>
        <cite className={props.num}>
          {props.name}
          {props.title ? <strong>{props.title}</strong> : null}
          {props.company ? <a href={props.website} target='_blank' rel='noreferrer'>{props.company}</a> : null}
          {props.location ? <em>{props.location}</em> : null}
        </cite>
      </blockquote>
    </div>
  );
};

export default slide;
